module.exports = __webpack_public_path__ + "assets/img/data-monitoring.981a79ae.png";